module.exports = __webpack_public_path__ + "img/hr-green-pita-12.7783a1ec.png";